/* eslint-disable no-nested-ternary */
// src/components/DeviceModals/ModalDevice16.js
import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import Modal from "@mui/material/Modal";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import SensorReading from "../cardDevices/SensorReading";

const UNIT_MAP = {
  62: "ºC",
  29: "%",
  95: "",
  96: "ppm",
  97: "ppb",
  219: "µg/m³",
  63: "K",
  64: "°F",
  53: "Pa",
  54: "kPa",
  55: "bar",
  56: "psi",
  18: "Wh",
  19: "kWh",
  48: "kW",
  49: "MW",
  52: "TR",
  84: "CFM",
  85: "m³/s",
  88: "L/min",
  89: "GPM",
  70: "d",
  71: "h",
  72: "min",
  73: "s",
  75: "km/h",
  78: "mph",
};
const getColour = (value, normalizePoint, riskPoint, isPositive) => {
  if (value == null) return "grey";

  if (isPositive) {
    if (value < riskPoint) return "red";
    if (value >= riskPoint && value < normalizePoint) return "orange";
    if (value >= normalizePoint) return "green";
    return "grey";
  }

  if (value <= normalizePoint) return "green";
  if (value > normalizePoint && value < riskPoint) return "orange";
  if (value >= riskPoint) return "red";
  return "grey";
};

const formatValue = (value) => (value === null ? "--" : value);
function ModalDevice16({ open, onClose, device, addressesMap }) {
  const addrMap = useMemo(() => new Map(Object.entries(addressesMap)), [addressesMap]);

  const renderProp = (property) => {
    const address = addrMap.get(property?.address) || {};
    return (
      <SensorReading
        key={property?.address}
        label={property?.label || ""}
        value={formatValue(address?.value)}
        unit={property?.unit || UNIT_MAP[address?.unit] || ""}
        color={getColour(
          address.value,
          property?.normalizePoint,
          property?.riskPoint,
          property?.isPositive
        )}
      />
    );
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-secondary-props-title"
      style={{ overflow: "scroll" }}
    >
      <Card
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90vw", sm: "75vw", md: "65vw" },
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          outline: "none",
        }}
      >
        <MDBox
          p={2}
          display="flex"
          flexWrap="wrap"
          justifyContent="center"
          gap={3}
          sx={{ overflowY: "auto" }}
        >
          {(device?.secondaryProperties || []).map(renderProp)}
        </MDBox>
      </Card>
    </Modal>
  );
}

ModalDevice16.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  device: PropTypes.object,
  addressesMap: PropTypes.object,
};
ModalDevice16.defaultProps = { open: false, onClose: () => {}, device: {}, addressesMap: {} };

const areEqual = (prev, next) => {
  if (prev.open !== next.open) return false;
  if (prev.device?.nodeId !== next.device?.nodeId) return false;
  const ids = (prev.device?.secondaryProperties ?? []).map((x) => x.address);
  return !ids.some((id) => prev.addressesMap[id]?.value !== next.addressesMap[id]?.value);
};

export default memo(ModalDevice16, areEqual);
